import { CheckOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { t } from "@impero-com/common/utils/i18n";
import { Alert, Button, Modal, useLocalStorage } from "@impero-com/ui";
import { useNavigate } from "react-router-dom";

import { controlEntitiesListUrl } from "../../controlEntities/urlUtils";

import * as styles from "./EntityManagementNotice.css";

const INTRODUCTION_SEEN_KEY = "riskEntitiesIntroductionSeen";

const BENEFITS = [
    {
        title: "RiskManager_EntityManagement_Introduction_AccessRights_Title",
        description:
            "RiskManager_EntityManagement_Introduction_AccessRights_Description",
    },
    {
        title: "RiskManager_EntityManagement_Introduction_Assess_Title",
        description:
            "RiskManager_EntityManagement_Introduction_Assess_Description",
    },
    {
        title: "RiskManager_EntityManagement_Introduction_Separation_Title",
        description:
            "RiskManager_EntityManagement_Introduction_Separation_Description",
    },
] as const;

interface EntityManagementNoticeProps {
    canCreateEntities: boolean;
}

export function EntityManagementNotice({
    canCreateEntities,
}: EntityManagementNoticeProps) {
    const navigate = useNavigate();
    const [introductionSeen, setIntroductionSeen] = useLocalStorage(
        INTRODUCTION_SEEN_KEY,
        false
    );

    const openEntities = () => {
        setIntroductionSeen(true);
        navigate(controlEntitiesListUrl);
    };

    return (
        <>
            <Alert
                className={styles.notice}
                role="region"
                aria-label={t("RiskManager_EntityManagement_Notice_Label")}
                type="info"
                icon={<InfoCircleOutlined />}
                message={t("RiskManager_EntityManagement_Notice_Title")}
                description={
                    canCreateEntities
                        ? t("RiskManager_EntityManagement_Notice_Description")
                        : t(
                              "RiskManager_EntityManagement_Notice_DescriptionAskForRole"
                          )
                }
                action={
                    canCreateEntities && (
                        <Button onClick={openEntities}>
                            {t("RiskManager_EntityManagement_OpenEntities")}
                        </Button>
                    )
                }
            />
            {canCreateEntities && (
                <Modal
                    variant="content"
                    width={640}
                    open={!introductionSeen}
                    onClose={() => setIntroductionSeen(true)}
                    title={t("RiskManager_EntityManagement_Introduction_Title")}
                    footer={
                        <>
                            <Button onClick={() => setIntroductionSeen(true)}>
                                {t(
                                    "RiskManager_EntityManagement_Introduction_NotNow"
                                )}
                            </Button>
                            <Button variant="primary" onClick={openEntities}>
                                {t("RiskManager_EntityManagement_OpenEntities")}
                            </Button>
                        </>
                    }
                >
                    <p className={styles.introduction}>
                        {t("RiskManager_EntityManagement_Introduction_Body")}
                    </p>
                    <ul className={styles.benefits}>
                        {BENEFITS.map(({ title, description }) => (
                            <li key={title} className={styles.benefit}>
                                <span className={styles.benefitIcon}>
                                    <CheckOutlined />
                                </span>
                                <div className={styles.benefitText}>
                                    <div className={styles.benefitTitle}>
                                        {t(title)}
                                    </div>
                                    <div className={styles.benefitDescription}>
                                        {t(description)}
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </Modal>
            )}
        </>
    );
}
